export default "__VITE_ASSET__d6d130cc__"